import Axios from 'axios';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import config from './config';
import i18n from '../i18n';

export const getEnv = (cname) => {
  if (cname.includes('localhost')) {
    return 'local';
  } else if (cname.includes('dev')) {
    return 'dev';
  } else if (cname.includes('stage')) {
    return 'stage';
  } else if (cname.includes('np')) {
    return 'uat';
  } else {
    return 'prod';
  }
};

export const axiosResponseHandler = (response) => {
  const oAuthtoken = Cookies.get('authorization');
  const JwtToken = Cookies.get('token');
  if (!oAuthtoken || !JwtToken) {
    Cookies.set('redirectUrl-' + getEnv(config.cname), window.location.href, { domain: config.cname });
    window.location.href = config.ssoUrl;
    localStorage.removeItem('viewedFiles');
  }
  return response;
};

export const delayRetryRequest = (error) =>
  new Promise<void>((resolve) => {
    setTimeout(() => {
      console.log('retry the request', error.config.url);
      resolve();
    }, error.config.retryDelay || 1000);
  });

export const handleErrorStatus = (status, error) => {
  if (status === 401|| status === 400) {
    Cookies.set('redirectUrl-' + getEnv(config.cname), window.location.href, { domain: config.cname });
    // redirect to the login page
    window.location.href = config.ssoUrl;
    localStorage.removeItem('viewedFiles');
  } else if (status === 404) {
    window.location.href = '/not-found';
  } else if (
    error.config.retry >= 2 &&
    (status === 403 || error.code === 'ERR_NETWORK' || error.message === 'Network Error')
  ) {
    error.config.retry -= 1;
    return delayRetryRequest(error).then(() => Axios(error.config));
  } else if (status === 500 && !error.config?.url?.includes('/documents/classification')) {
    const toastOptions = { toastId: error.config?.requestId };
    toast.error(i18n.t('common.internalServerError'), toastOptions);
  }
};

export const axiosErrorHandler = (error) => {
  const status = error.response?.status || 500;
  handleErrorStatus(status, error);
  if (error.response?.data) {
    return Promise.reject(error.response.data);
  }
  return Promise.reject(error);
};

export const configAxios = (configObject = {}) => {
  const innerConfigureAxios = (axiosConfig: any) => {
    if (isNaN(axiosConfig.retry) && axiosConfig?.method?.toLowerCase() === 'get') {
      axiosConfig.retry = 3;
      axiosConfig.retryDelay = 100;
    }
    const oAuthtoken = Cookies.get('authorization');
    const userId = Cookies.get('userId');
    const userRole = Cookies.get('userRole')?.split('/').join(',');
    const JwtToken = Cookies.get('token');
    if (!axiosConfig.headers) {
      axiosConfig.headers = {};
    }
    const env = getEnv(`${config.cname}`);
    axiosConfig.headers.Accept = 'text/html, application/json';
    axiosConfig.withCredentials = false;
    axiosConfig.headers.authorization = `Bearer ${oAuthtoken}`;
    axiosConfig.headers['WM_CONSUMER.ID'] = `${config.consumerId}` ?? '';
    axiosConfig.headers['WM_SVC.NAME'] = 'ACNT_WS';
    axiosConfig.headers['WM_SVC.ENV'] = env;
    axiosConfig.headers.token = `Bearer ${JwtToken}` ?? '';
    if (userId) {
      axiosConfig.headers.userId = userId;
    }
    if (userRole) {
      axiosConfig.headers.userRole = userRole.replace(/\//g, ',');
    }
    const requestId = axiosConfig.url?.split('?')[0]?.split('/').reverse()[0];
    axiosConfig.requestId = requestId;
    return axiosConfig;
  };
  const confAxiosObject = innerConfigureAxios(configObject);
  Axios.interceptors.request.use((_defaultConf) => {
    const mergedConfig = Object.assign(_defaultConf, confAxiosObject);
    mergedConfig.headers['Accept-Language'] = i18n.language || 'en';
    return mergedConfig;
  });
  Axios.interceptors.response.use(axiosResponseHandler, axiosErrorHandler);
  return confAxiosObject;
};

export default configAxios;
